import React from "react";
import styled from "styled-components";
import YouTube from "react-youtube";

const Wrapper = styled.div<{ ratio: number }>`
	padding-top: ${(props) => `${props.ratio}%`};
	position: relative;
`;

const CustomVideo = styled(YouTube)`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
`;

const SourceVideo: React.FC<{ source: string; className?: string; ratio?: number }> = ({ source, className, ratio = 56 }) => {
	return (
		<Wrapper className={className} ratio={ratio}>
			<CustomVideo
				videoId={source} // defaults -> null
				// id={string}                       // defaults -> null
				// className={string}                // defaults -> null
				// containerClassName={string}       // defaults -> ''
				opts={{
					width: "100%",
					height: "100%",
					playerVars: {
						color: "white"
					}
				}} // defaults -> {}
				// onReady={func}                    // defaults -> noop
				// onPlay={func}                     // defaults -> noop
				// onPause={func}                    // defaults -> noop
				// onEnd={func}                      // defaults -> noop
				// onError={func}                    // defaults -> noop
				// onStateChange={func}              // defaults -> noop
				// onPlaybackRateChange={func}       // defaults -> noop
				// onPlaybackQualityChange={func}    // defaults -> noop
			/>
		</Wrapper>
	);
};

export default SourceVideo;
